import mutations from './mutations';
import queries from './queries';

export const handlers = [
  ...queries,
  ...mutations,
  // ...custom
];
